import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { subscribeNewsletter } from "@/lib/api/intake.functions";
import { toast } from "sonner";

const CONSENT_TEXT =
  "I agree to receive the free CCMA checklist plus occasional labour-law tips from Nkadimeng Danny Legal & Compliance Support. I can unsubscribe at any time.";

export function NewsletterForm() {
  const subscribe = useServerFn(subscribeNewsletter);
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (!email) return;
        if (!consent) {
          toast.error("Please tick the POPIA consent box to subscribe.");
          return;
        }
        setLoading(true);
        try {
          await subscribe({
            data: { email, consent: true, consentText: CONSENT_TEXT },
          });
          toast.success("You're subscribed. Thank you!");
          setEmail("");
          setConsent(false);
        } catch (err) {
          toast.error(err instanceof Error ? err.message : "Could not subscribe");
        } finally {
          setLoading(false);
        }
      }}
      className="space-y-2"
    >
      <div className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 rounded-md border border-navy-foreground/15 bg-navy-foreground/5 px-3 py-2 text-sm text-navy-foreground placeholder:text-navy-foreground/40 focus:border-gold focus:outline-none"
        />
        <button
          type="submit"
          disabled={loading}
          className="rounded-md bg-gold px-4 py-2 text-sm font-semibold text-gold-foreground hover:brightness-95 disabled:opacity-60"
        >
          {loading ? "..." : "Join"}
        </button>
      </div>
      <label className="flex items-start gap-2 text-[11px] leading-snug text-navy-foreground/70">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-0.5 h-3.5 w-3.5 shrink-0 accent-gold"
        />
        <span>
          POPIA consent: I agree to receive emails. Unsubscribe any time via the
          link in every email or at{" "}
          <a href="/unsubscribe" className="underline hover:text-gold">
            /unsubscribe
          </a>
          .
        </span>
      </label>
    </form>
  );
}
